// =======================
// Stable Swiper for .product-media-swiper (bullets only)
// - No progress bar
// - No duplicate inits
// - No destroy/reinit during scroll (mobile address bar resize)
// =======================

(function () {
    'use strict';

    const swiperByEl = new WeakMap();
    let lastIsMobile = null; // 'true' when <= 749px

    // -------- Destroy (scoped) --------
    function destroySwiper(el) {
        const inst = swiperByEl.get(el);
        if (inst && typeof inst.destroy === 'function') {
            try { inst.destroy(true, true); } catch (e) { }
        }
        swiperByEl.delete(el);

        const pag = el.querySelector('.mobile-product-media-pagination');
        if (pag) pag.remove();
    }

    // -------- Init (scoped, bullets only) --------
    function initSwiper(el) {
        if (!el || swiperByEl.has(el)) return;

        if (!el.classList.contains('.product-media-swiper')) el.classList.add('swiper');

        let pag = el.querySelector('.mobile-product-media-pagination');
        if (!pag) {
            pag = document.createElement('div');
            pag.className = 'mobile-product-media-pagination';
            el.appendChild(pag);
        }

        const inst = new Swiper(el, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            resizeObserver: true,
            speed: 300,
            effect: 'slide',
            pagination: {
                el: pag,
                clickable: true,
                type: 'bullets',
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
                renderBullet: function (index, className) {
                    var slides = el.querySelectorAll('.swiper-slide');
                    var isVideo = false;
                    if (slides[index]) {
                        var container = slides[index].querySelector('.product-media-container');
                        if (container && (container.classList.contains('media-type-video') || container.classList.contains('media-type-external_video') || container.classList.contains('product-media-container--video'))) {
                            isVideo = true;
                        }
                        if (!isVideo && slides[index].querySelector('video, deferred-media video')) {
                            isVideo = true;
                        }
                    }
                    if (isVideo) {
                        return '<span class="' + className + ' swiper-pagination-bullet--video" data-index="' + index + '"><svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.8292 5.16381C11.1073 5.31705 11.3399 5.54581 11.5021 5.82558C11.6643 6.10535 11.75 6.42558 11.75 6.75196C11.75 7.07834 11.6643 7.39857 11.5021 7.67834C11.3399 7.95811 11.1073 8.18687 10.8292 8.34011L3.41151 12.5202C2.2171 13.194 0.75 12.318 0.75 10.9326V2.57188C0.75 1.18592 2.2171 0.310551 3.41151 0.983131L10.8292 5.16381Z" stroke="#AFAFAF" stroke-width="1.5"/></svg></span>';
                    }
                    return '<span class="' + className + '" data-index="' + index + '"></span>';
                }
            },
            on: {
                init: function () {
                    pag.classList.remove('swiper-pagination-progressbar');
                    const fill = pag.querySelector('.swiper-pagination-progressbar-fill');
                    if (fill) fill.remove();

                    this.updatePaginationClasses = function () {
                        const bullets = Array.from(this.pagination.bullets || []);
                        const activeIndex = this.activeIndex;

                        bullets.forEach((bullet, index) => {
                            const distance = Math.abs(parseInt(bullet.getAttribute('data-index')) - activeIndex);
                            bullet.classList.remove('is-near-1', 'is-near-2');
                            if (distance === 1) bullet.classList.add('is-near-1');
                            else if (distance === 2) bullet.classList.add('is-near-2');
                        });
                    }.bind(this);

                    this.updatePaginationClasses();
                },
                slideChange: function () {
                    if (typeof this.updatePaginationClasses === 'function') {
                        this.updatePaginationClasses();
                    }
                },
                paginationUpdate: function () {
                    if (typeof this.updatePaginationClasses === 'function') {
                        this.updatePaginationClasses();
                    }
                }
            }
        });

        if (!document.getElementById('swiper-pagination-styles')) {
            const style = document.createElement('style');
            style.id = 'swiper-pagination-styles';
            style.textContent = `/* pagination styles */ 
          .mobile-product-media-pagination{position:absolute;display:flex;justify-content:left;align-items:center;margin-top:15px;padding:8px 10px;gap:6px;z-index:10}
          .swiper-pagination-bullet{width:15px;height:1px;border-radius:20px;background:rgba(0,0,0,.2);margin:0!important;transition:all .3s cubic-bezier(.4,0,.2,1);cursor:pointer;border:none;outline:none;padding:0;opacity:.6}
          .swiper-pagination-bullet-active{width:25px;border-radius:20px;background:#000;opacity:1}
          .swiper-pagination-bullet.is-near-1{opacity:.8}
          .swiper-pagination-bullet.is-near-2{opacity:.7}
          .swiper-pagination-bullet:hover{opacity:1;transform:scale(1.1)}
          .swiper-pagination-bullet-active:hover{transform:none}
          .swiper-pagination-bullet--video{width:auto;height:auto;border-radius:0;background:transparent;display:inline-flex;align-items:center;justify-content:center;padding:0;color:rgba(0,0,0,.3)}
          .swiper-pagination-bullet--video svg{display:block;width:8px;height:8px;transition:all .3s cubic-bezier(.4,0,.2,1)}
          .swiper-pagination-bullet--video.swiper-pagination-bullet-active{background:transparent;color:#000;opacity:1}
          .swiper-pagination-bullet--video.is-near-1{opacity:.8}
          .swiper-pagination-bullet--video.is-near-2{opacity:.7}
          .swiper-pagination-bullet--video:hover{opacity:1;transform:scale(1.15)}
          .swiper-pagination-bullet--video.swiper-pagination-bullet-active:hover{transform:none}
          .swiper-pagination-bullet--video.swiper-pagination-bullet-active svg path{stroke:#000}`;
            document.head.appendChild(style);
        }

        swiperByEl.set(el, inst);
    }

    // -------- Apply mode (mobile/desktop) only when breakpoint actually changes --------
    function initAllSwipers(force = false) {
        const isMobile = window.innerWidth <= 750;
        if (!force && lastIsMobile === isMobile) return;

        document.querySelectorAll('.product-media-swiper').forEach(el => {
            if (!el || !el.isConnected) return;
            if (isMobile) {
                destroySwiper(el);
                initSwiper(el);
            } else {
                destroySwiper(el);
            }
        });

        lastIsMobile = isMobile;
    }

    // -------- Variant logic --------
    function processVariantCustom() {
        var today = new Date();
        const infoWrapper = document.querySelector('.product__info-wrapper');
        if (!infoWrapper) return;

        // ✅ Get all fieldsets
        const fieldsets = document.querySelectorAll('fieldset');

        // ✅ Collect only one checked input per fieldset
        const selected_variant_values = Array.from(fieldsets).map(fs => {
            const checked = fs.querySelector('input:checked');
            return checked ? checked.value : null;
        }).filter(Boolean); // null hatane ke liye

        // ✅ Remove duplicates (if desktop/mobile dono inputs aaye)
        const unique_values = [...new Set(selected_variant_values)];

        // ✅ Join string
        const selected_variant = unique_values.join(" / ");
        const productWishlistbutton = infoWrapper.querySelector('.wishlist_button');



        if (!selected_variant) return;

        if (typeof p_variants !== 'undefined' && Array.isArray(p_variants)) {
            p_variants.forEach(i3 => {
                if (i3.title == selected_variant) {
                    if (productWishlistbutton) {
                        productWishlistbutton.setAttribute('data-product-variant-id', i3.id);
                        productWishlistbutton.setAttribute('data-selected-variant-value', i3.option1);
                    }
                    document.querySelectorAll('.stock-label').forEach(el => el.style.display = 'none');
                    // Show selected
                    const target = document.querySelector(`.stock-label[data-variant-id="${i3.id}"]`);
                    if (target) target.style.display = 'flex';

                    document.querySelectorAll('.estimated-delivery').forEach(el => el.style.display = 'none');
                    // Show selected
                    const dlivery_target = document.querySelector(`.estimated-delivery[data-variant-id="${i3.id}"]`);
                    if (dlivery_target) dlivery_target.style.display = 'block';

                    let variant_images = "";
                    if (i3.variant_image) {
                        const grid = document.querySelector(".product__media-list");
                        const gridImg = document.querySelector(".product__media-list img");
                        const swiper = document.querySelector(".product-media-swiper");
                        const swiperImg = document.querySelector(".product-media-swiper img");
                        if (grid) {
                            grid.style.transition = 'opacity 0.5s';
                            grid.offsetHeight; // reflow
                            grid.style.opacity = '0';
                            gridImg.style.transition = 'opacity 1s';
                            gridImg.offsetHeight; // reflow
                            gridImg.style.opacity = '0';
                        }
                        if (swiper) {
                            swiper.style.transition = 'opacity 0.5s';
                            swiper.offsetHeight; // reflow
                            swiper.style.opacity = '0';
                            swiperImg.style.transition = 'opacity 1s';
                            swiperImg.offsetHeight; // reflow
                            swiperImg.style.opacity = '0';
                        }

                        setTimeout(() => {
                            if (window.innerWidth <= 750) {
                                variant_images += '<div class="swiper-wrapper">';
                                i3.variant_image.forEach(media => {
                                    if (typeof media === "string") {
                                        variant_images += `
                                        <div class="swiper-slide product__media-item scroll-trigger animate--fade-in swiper-slide-active" role="group" aria-label="1 / 3" style="margin-right: 10px;">
          

                                        <div class="product-media-container media-type-image media-fit-fill global-media-settings gradient" style="--ratio: 0.8; --preview-ratio: 0.8;">
                                        <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#ProductModal-template--25018520174871__main">

                                        <div class="loading__spinner hidden">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>

                                        </div>
                                        <div class="product__media media media--transparent">
                                            <img src="${media}" alt="" srcset="${media.replace(/width=\d+/g, 'width=246')} 246w, ${media.replace(/width=\d+/g, 'width=493')} 493w, ${media.replace(/width=\d+/g, 'width=600')} 600w, ${media.replace(/width=\d+/g, 'width=713')} 713w, ${media.replace(/width=\d+/g, 'width=823')} 823w, ${media.replace(/width=\d+/g, 'width=990')} 990w, ${media.replace(/width=\d+/g, 'width=1100')} 1100w, ${media.replace(/width=\d+/g, 'width=1206')} 1206w, ${media.replace(/width=\d+/g, 'width=1346')} 1346w, ${media.replace(/width=\d+/g, 'width=1426')} 1426w, ${media.replace(/width=\d+/g, 'width=1646')} 1646w, ${media.replace(/width=\d+/g, 'width=1946')} 1946w" width="1946" height="2433" loading="lazy" class="image-magnify-lightbox" sizes="(min-width: 1200px) 715px, (min-width: 990px) calc(65.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
                                            </div>
                                        </modal-opener></div>

                                                </div>`;
                                    } else if (media.media_type === "video" && media.sources) {
                                        var videoPoster = (media.preview_image && media.preview_image.src) ? media.preview_image.src : '';
                                        variant_images += `<div class="swiper-slide">
                                        <div class="product-media-container product-media-container--video media-fit" style="--ratio: 0.8; --preview-ratio: 0.8;">
                                        <div class="product__media media media--transparent">
                                        <deferred-media><video autoplay loop muted playsinline${videoPoster ? ' poster="' + videoPoster + '"' : ''} data-poster="${videoPoster}">`;
                                        media.sources.forEach(source => {
                                            if (source.mime_type.includes("video")) {
                                                variant_images += `<source src="${source.url}" type="${source.mime_type}">`;
                                            }
                                        });
                                        variant_images += `Your browser does not support the video tag.</video></deferred-media></div></div></div>`;
                                    }
                                });
                                variant_images += "</div>";

                                document.querySelector("media-gallery").innerHTML = `<div class="product-media-swiper swiper">${variant_images}</div>`;

                                setTimeout(() => {
                                    initAllSwipers(true);
                                    const container = document.querySelector('.product-media-swiper');
                                    if (container) initCustomZoom(container);
                                }, 100);

                            } else {
                                variant_images = "";
                                i3.variant_image.forEach(media => {
                                    if (typeof media === "string") {

                                        variant_images += `
                      <li class="product__media-item grid__item slider__slide is-active scroll-trigger animate--fade-in" 
                            data-media-id="template--25018520174871__main-40888521785623">

                            <div class="product-media-container media-type-image media-fit-cover global-media-settings gradient constrain-height" style="--ratio: 0.8; --preview-ratio: 0.8;">
                            <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#ProductModal-template--25018520174871__main">
                                

                            <div class="loading__spinner hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>

                            </div>
                            <div class="product__media media media--transparent">
                                <img src="${media}?width=1946" alt="" srcset="${media}?width=246 246w, ${media}?width=493 493w, ${media}?width=600 600w, ${media}?width=713 713w, ${media}?width=823 823w, ${media}?width=990 990w, ${media}?width=1100 1100w, ${media}?width=1206 1206w, ${media}?width=1346 1346w, ${media}?width=1426 1426w, ${media}?width=1646 1646w, ${media}?width=1946 1946w" width="1946" height="2433" loading="lazy" class="image-magnify-lightbox" sizes="(min-width: 1200px) 715px, (min-width: 990px) calc(65.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
                                </div>
                            </modal-opener></div>

                                    </li>
                      `;
                                    } else if (media.media_type === "video" && media.sources) {
                                        variant_images += `
                                        <li  class="product__media-item grid__item slider__slide product__media-item--full scroll-trigger animate--fade-in">
                                        <div class="product-media-container media-type-video media-fit-cover global-media-settings gradient constrain-height" style="--ratio: 0.838; --preview-ratio: 0.8382352941176471;">
                                        <deferred-media class="deferred-media media media--transparent" data-media-id="39388036956458">
                                        <video autoplay loop muted playsinline${(media.preview_image && media.preview_image.src) ? ' poster="' + media.preview_image.src + '"' : ''} data-poster="${(media.preview_image && media.preview_image.src) || ''}">`;
                                        media.sources.forEach(source => {
                                            if (source.mime_type.includes("video")) {
                                                variant_images += `<source src="${source.url}" type="${source.mime_type}">`;
                                            }
                                        });
                                        variant_images += `</video></deferred-media></div></li>`;
                                    }
                                });
                                grid.innerHTML = variant_images;
                            }
                            if (grid) {
                                grid.style.transition = 'opacity 0.5s';
                                grid.offsetHeight; // reflow
                                grid.style.opacity = '1';
                                gridImg.style.transition = 'opacity 1s';
                                gridImg.offsetHeight; // reflow
                                gridImg.style.opacity = '1';
                            }
                            if (swiper) {
                                swiper.style.transition = 'opacity 0.5s';
                                swiper.offsetHeight; // reflow
                                swiper.style.opacity = '1';
                                swiperImg.style.transition = 'opacity 1s';
                                swiperImg.offsetHeight; // reflow
                                swiperImg.style.opacity = '1';
                            }
                        }, 1000);

                    } else {
                        const mobile_img = document.querySelector(".product-media-swiper .swiper-slide img");
                        const img = document.querySelector(".product__media-list li img");
                        const container = document.querySelector('.product-media-swiper');
                        if (img && mobile_img && container && i3.featured_image && i3.featured_image.src) {
                            const media = i3.featured_image.src;
                            const newSrc = media;
                            const newSrcset = `${media};width=300 300w,${media};width=450 450w,${media};width=600 600w,${media};width=750 750w,${media};width=900 900w`;
                            fadeOutIn(img, newSrc, newSrcset);
                            fadeOutIn(mobile_img, newSrc, newSrcset);
                        }
                        if (container) initCustomZoom(container);
                    }
                }
            });
        }
    }

    // -------- Fade helpers --------
    function fadeOutIn(el, newSrc, newSrcset) {
        el.style.transition = "opacity 0.2s";
        el.style.opacity = 0;
        setTimeout(() => {
            el.src = newSrc;
            if (newSrcset) el.srcset = newSrcset;
            el.style.transition = "opacity 0.4s";
            el.style.opacity = 1;
        }, 500);
    }


    // -------- Custom Zoom Functionality --------
    class CustomZoom {
        constructor() {
            this.dialog = null;
            this.media = [];
            this.currentIndex = 0;
            this.setup();
        }

        disableParentScroll() {
            this._slideLocked = true;
        }
        enableParentScroll() {
            this._slideLocked = false;
        }



        setup() {
            if (document.getElementById("custom-zoom-dialog")) {
                this.dialog = document.getElementById("custom-zoom-dialog");
                this.thumbs = this.dialog.querySelector("[ref='thumbnails']");
                this.content = this.dialog.querySelector(
                    ".dialog-zoomed-gallery__content"
                );
                return;
            }

            const html = `
        <div id="custom-zoom-dialog" hidden>
          <button class="close-btn" aria-label="Close">&times;</button>
          <div class="dialog-thumbnails-list" ref="thumbnails"></div>
          <div class="dialog-zoomed-gallery__content"></div>
        </div>`;
            document.body.insertAdjacentHTML("beforeend", html);

            const style = document.createElement("style");
            style.textContent = `
        #custom-zoom-dialog{position:fixed;inset:0;background:rgba(0,0,0,0.9);z-index:1000;display:flex;flex-direction:column;align-items:center;justify-content:center}
        #custom-zoom-dialog[hidden]{display:none!important}
        .close-btn{position:absolute;top:15px;right:15px;background:#000;color:#fff;border:none;font-size:24px;cursor:pointer;z-index:1;}
        .dialog-thumbnails-list{position: fixed;bottom: 10px;width: 100%;overflow: auto;left: 0;padding: 10px;display:flex;gap:6px;margin-top:10px;overflow-x:auto;scrollbar-width:none;-ms-overflow-style: none;}
        .dialog-thumbnails-list img{width:60px;height:60px;object-fit:cover;cursor:pointer;opacity:.6;border:2px solid transparent;border-radius:6px;flex: 0 0 60px}
        .dialog-thumbnails-list img.active{opacity:1;border-color:#fff}.dialog-zoomed-gallery__content video{max-width:100%}
        .dialog-zoomed-gallery__content{width:100%;height:auto;display:flex;flex-direction:row;align-items: center}
        .dialog-zoomed-gallery__content > img, .dialog-zoomed-gallery__content > video{flex: 0 0 100%;}
        .dialog-zoomed-gallery__content > video{height: 60vh;object-fit: cover;}
        .dialog-zoomed-gallery__content img{max-width:100%;max-height:auto;object-fit:contain;animation:fadeIn .3s ease}
        .dialog-zoomed-gallery__content::-webkit-scrollbar, .dialog-thumbnails-list::-webkit-scrollbar{height: 0;width: 0;display: none;}
        .zoomable-media {cursor: zoom-in; transition: transform 0.25s ease; transform-origin: center center;}
        .zoomable-media.is-zoomed {cursor: grab;}
        .zoom-slide {
 flex: 0 0 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.zoom-pan-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.zoomable-media {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transform-origin: center center;
  transition: transform 0.25s ease;
  cursor: zoom-in;
}

.zoomable-media.is-zoomed {
  cursor: grab;
}
 .zoom-pan-wrapper { touch-action: pan-x pan-y pinch-zoom; }

.zoomable-media { touch-action: pan-x; }

.zoomable-media.is-zoomed { touch-action: none; }


        @keyframes fadeIn{from{opacity:0}to{opacity:1}}`;
            document.head.appendChild(style);

            this.dialog = document.getElementById("custom-zoom-dialog");
            this.thumbs = this.dialog.querySelector("[ref='thumbnails']");
            this.content = this.dialog.querySelector(".dialog-zoomed-gallery__content");

            this.dialog.querySelector(".close-btn").addEventListener("click", () => this.close());
            this.dialog.addEventListener("click", (e) => {
                if (e.target === this.dialog) this.close();
            });
        }

        open(index, mediaArr) {
            this.media = mediaArr;
            this.currentIndex = index;

            this._opening = true;
            this._ignoreScrollSync = true;

            this.dialog.hidden = false;
            document.body.style.overflow = "hidden";

            // 👇 pass flag
            this.updateDialog(true);

            setTimeout(() => {
                this._opening = false;
                this._ignoreScrollSync = false;
            }, 50);
        }



        close() {
            this.dialog.hidden = true;
            document.body.style.overflow = "";
            syncProductMediaVideos(document.querySelector(".product__media-wrapper"));
        }

        updateDialog(isInitialOpen = false) {
            if (!isInitialOpen) return;

            this.content.innerHTML = "";
            this.thumbs.innerHTML = "";

            /* -----------------------------
               🔹 RENDER THUMBNAILS
            ----------------------------- */
            this.media.forEach((m, i) => {
                const thumb = document.createElement("img");
                thumb.src = m.poster || m.src;
                thumb.alt = "";
                thumb.dataset.index = i;

                if (i === this.currentIndex) thumb.classList.add("active");

                thumb.onclick = () => {
                    this.scrollToIndex(i);
                };

                this.thumbs.appendChild(thumb);
            });

            /* -----------------------------
               🔹 RENDER MAIN CONTENT
            ----------------------------- */
            this.media.forEach((m, i) => {
                const slide = document.createElement("div");
                slide.className = "zoom-slide";
                slide.dataset.index = i;

                if (m.type === "image") {
                    const pan = document.createElement("div");
                    pan.className = "zoom-pan-wrapper";

                    const img = document.createElement("img");
                    img.src = m.src;
                    img.className = "zoomable-media";
                    img.dataset.scale = 1;
                    img.dataset.x = 0;
                    img.dataset.y = 0;

                    pan.appendChild(img);
                    slide.appendChild(pan);

                    // ✅ enable zoom ONLY on img
                    this.enableAdvancedZoom(img);

                } else {
                    const video = document.createElement("video");
                    video.src = m.src;
                    video.autoplay = true;
                    video.defaultMuted = true;
                    video.loop = true;
                    video.muted = true;
                    video.controls = true;
                    video.playsInline = true;
                    video.setAttribute("webkit-playsinline", "");
                    video.className = "zoomed-gallery__video";
                    slide.appendChild(video);
                }

                this.content.appendChild(slide);
            });

            /* -----------------------------
               ✅ INSTANT POSITION (NO SCROLL, NO TRAVEL)
            ----------------------------- */
            const target = this.content.querySelector(
                `[data-index="${this.currentIndex}"]`
            );

            if (target) {
                // temporarily disable snap & smooth
                this.content.style.scrollSnapType = "none";
                this.content.style.scrollBehavior = "auto";

                // direct jump
                this.content.style.transition = "none";
                this.content.style.transform = `translateX(-${this.currentIndex * 100}%)`;

                // restore snap behavior
                requestAnimationFrame(() => {
                    this.content.style.transition = "transform 0.35s ease";
                });
            }

            this.setActiveThumb(this.currentIndex);

            /* -----------------------------
               🔁 SCROLL SYNC + SNAP
            ----------------------------- */
            // this.bindScrollSync();
            this.bindSnapScroll();
        }

        enableAdvancedZoom(el) {
            let scale = 1;
            let x = 0;
            let y = 0;
            let startX = 0;
            let startY = 0;
            let startDist = 0;
            let startScale = 1;
            let lastTap = 0;

            const apply = () => {
                const rect = el.getBoundingClientRect();
                const parent = el.parentElement.getBoundingClientRect();

                const maxX = (rect.width - parent.width) / 2;
                const maxY = (rect.height - parent.height) / 2;

                x = Math.max(-maxX, Math.min(x, maxX));
                y = Math.max(-maxY, Math.min(y, maxY));

                el.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
            };


            const reset = () => {
                scale = 1;
                x = 0;
                y = 0;
                el.classList.remove("is-zoomed");
                this.enableParentScroll();
                apply();
                el.style.transform = "translate(0px, 0px) scale(1)";
            };

            el.addEventListener("touchstart", (e) => {
                // 🔥 DOUBLE TAP
                const now = Date.now();
                if (now - lastTap < 300 && e.touches.length === 1) {
                    if (scale > 1) {
                        reset();
                    } else {
                        scale = 2;
                        el.classList.add("is-zoomed");
                        this.disableParentScroll();
                        apply();
                    }
                    e.preventDefault();
                }
                lastTap = now;

                // PINCH START
                if (e.touches.length === 2) {
                    startDist = Math.hypot(
                        e.touches[0].clientX - e.touches[1].clientX,
                        e.touches[0].clientY - e.touches[1].clientY
                    );
                    startScale = scale;
                    this.disableParentScroll();
                }

                // PAN START
                if (e.touches.length === 1 && scale > 1) {
                    startX = e.touches[0].clientX - x;
                    startY = e.touches[0].clientY - y;
                    this.disableParentScroll();
                }
            });

            el.addEventListener("touchmove", (e) => {
                if (e.touches.length === 2) {
                    e.preventDefault();
                    const dist = Math.hypot(
                        e.touches[0].clientX - e.touches[1].clientX,
                        e.touches[0].clientY - e.touches[1].clientY
                    );
                    scale = Math.min(Math.max(startScale * (dist / startDist), 1), 3);
                    el.classList.toggle("is-zoomed", scale > 1);
                    apply();
                    return;
                }

                if (scale > 1 && e.touches.length === 1) {
                    e.preventDefault();
                    x = e.touches[0].clientX - startX;
                    y = e.touches[0].clientY - startY;
                    apply();
                }
            });

            el.addEventListener("touchend", () => {
                if (scale <= 1) reset();
            });
        }



        // ---------- SCROLL TO CONTENT ----------
        scrollToIndex(index) {
            index = Math.max(0, Math.min(index, this.media.length - 1));
            this.currentIndex = index;

            this.content.style.transition = "transform 0.35s ease";
            this.content.style.transform = `translateX(-${index * 100}%)`;

            this.setActiveThumb(index);
            syncMainThumbnails(index);
        }






        // ---------- SET ACTIVE THUMB ----------
        setActiveThumb(index) {
            this.currentIndex = index;

            this.thumbs.querySelectorAll("img").forEach((img, i) => {
                img.classList.toggle("active", i === index);
            });
        }

        // ---------- SCROLL ↔ THUMB SYNC ----------
        bindScrollSync() {
            if (this._scrollBound) return;
            this._scrollBound = true;

            this.content.addEventListener("scroll", () => {
                if (this._opening || this._ignoreScrollSync) return;
                const items = Array.from(this.content.children);
                const contentLeft = this.content.getBoundingClientRect().left;

                let activeIndex = 0;
                let minDiff = Infinity;

                items.forEach((el, i) => {
                    const diff = Math.abs(el.getBoundingClientRect().left - contentLeft);
                    if (diff < minDiff) {
                        minDiff = diff;
                        activeIndex = i;
                    }
                });

                if (activeIndex !== this.currentIndex) {
                    this.setActiveThumb(activeIndex);

                    // ✅ MAIN PAGE THUMB SYNC
                    syncMainThumbnails(activeIndex);
                }
            });
        }


        bindSnapScroll() {
            if (this._snapBound) return;
            this._snapBound = true;

            /* ---------- TOUCH (MOBILE) ---------- */
            let startX = 0;
            let deltaX = 0;
            let touching = false;
            const TOUCH_THRESHOLD = 60;

            this.content.addEventListener("touchstart", (e) => {
                if (this._slideLocked) return;
                if (this.content.querySelector(".zoomable-media.is-zoomed")) return;
                touching = true;
                startX = e.touches[0].clientX;
                deltaX = 0;
                this.content.style.transition = "none";
            }, { passive: true });

            this.content.addEventListener("touchmove", (e) => {
                if (!touching) return;
                deltaX = e.touches[0].clientX - startX;
            }, { passive: true });

            this.content.addEventListener("touchend", () => {
                if (!touching) return;
                touching = false;

                if (Math.abs(deltaX) < TOUCH_THRESHOLD) {
                    this.scrollToIndex(this.currentIndex);
                    return;
                }

                this.scrollToIndex(
                    deltaX < 0 ? this.currentIndex + 1 : this.currentIndex - 1
                );
            });

            /* ---------- WHEEL (DESKTOP) ---------- */
            let wheelLock = false;

            this.content.addEventListener("wheel", (e) => {
                if (this._slideLocked) return;
                e.preventDefault();
                if (wheelLock) return;
                if (this.content.querySelector(".zoomable-media.is-zoomed")) return;

                wheelLock = true;
                this.scrollToIndex(
                    e.deltaY > 0 || e.deltaX > 0
                        ? this.currentIndex + 1
                        : this.currentIndex - 1
                );

                setTimeout(() => wheelLock = false, 400);
            }, { passive: false });
        }

    }

    const customZoom = new CustomZoom();

    function initCustomZoom(container) {
        if (!container) return;

        // 🔧 FIX: collect IMAGE + VIDEO in same DOM order
        const mediaEls = Array.from(
            container.querySelectorAll(".product__media img, .product__media video")
        );

        const mediaArr = mediaEls.map(el => {
            if (el.tagName === "IMG") {
                const src = el.currentSrc || el.src;
                return {
                    type: "image",
                    src: src,
                    poster: src
                };
            } else {
                return {
                    type: "video",
                    src: el.currentSrc || el.src || el.querySelector("source")?.src || "",
                    poster:
                        el.poster ||
                        el.getAttribute("data-poster") ||
                        el.closest(".product__media")?.querySelector("img")?.currentSrc ||
                        el.closest(".product-media-container")?.querySelector("img")?.currentSrc ||
                        el.closest(".swiper-slide")?.querySelector("img")?.currentSrc ||
                        ""
                };
            }
        });


        mediaEls.forEach((el, index) => {
            if (el.tagName === "VIDEO") {
                el.style.cursor = "zoom-in";
                el.onclick = (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    customZoom.open(index, mediaArr);
                };
                return;
            }

            el.style.cursor = "zoom-in";
            el.onclick = () => customZoom.open(index, mediaArr);
        });
    }

    // -------- Init on DOM --------
    document.addEventListener('DOMContentLoaded', () => {
        const container = document.querySelector('.product-media-swiper, .product__media-list');
        if (container) initCustomZoom(container);
    });

    const originalProcessVariantCustom = processVariantCustom;
    window.processVariantCustom = function () {
        originalProcessVariantCustom.apply(this, arguments);
        setTimeout(() => {
            const container = document.querySelector('.product-media-swiper, .product__media-list');
            if (container) initCustomZoom(container);
        }, 100);
    };

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            const container = document.querySelector('.product-media-swiper, .product__media-list');
            if (container) initCustomZoom(container);
        }, 500);
    });

    // -------- Boot --------
    initAllSwipers(true);

    const mql = window.matchMedia('(max-width: 750px)');
    if (mql.addEventListener) {
        mql.addEventListener('change', () => initAllSwipers());
    } else {
        mql.addListener(() => initAllSwipers());
    }

    // Variant change (delegated)
    document.addEventListener("change", e => {
        if (e.target.matches(".product__info-wrapper fieldset input[type='radio']")) {
            setTimeout(processVariantCustom, 500);
        }
    });

    processVariantCustom();
})();
